/**
 * Builds an options list that must name every member of a string-enum union:
 * omit one and the call does not typecheck, add a stranger and it does not
 * either.
 *
 * The alternative - reading the members off Prisma's generated runtime enum -
 * is only open to server code. Client components import the modules that list
 * these options, and a value import from `@prisma/client` would drag the Prisma
 * client into the browser bundle. So the members are written out once, and this
 * checks the writing against the type.
 *
 *     export const TUTOR_VOICE_OPTIONS = allOf<TutorVoice>()(["NOVA", ...] as const);
 */
export function allOf<T extends string>() {
  return <O extends readonly T[]>(options: Exclude<T, O[number]> extends never ? O : never): O =>
    options;
}
